// extracted by mini-css-extract-plugin
module.exports = {"textContent":"TextContent-module--text-content--67568","textContent__content":"TextContent-module--text-content__content--1gN-W"};